import {
  GOTO_SECTION,
  TOGGLE_SIDEBAR,
  DISPLAY_MAIN_HEADER,
  DISPLAY_LOADER,
  DISPLAY_FETCHING_LOADER,
  DISPLAY_GQ_LOADER,
} from '../../constants/types'


export const INITIAL_STATE = {
  topnavSection: 'home',
  displayMainHeader: true,
  isLoading: false,
  isFetching: false,
  isGQLoading: false,
}

export const Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case GOTO_SECTION:
    return { ...state, topnavSection: action.payload }
  case TOGGLE_SIDEBAR:
    return { ...state, sidebarVisible: !state.sidebarVisible }
  case DISPLAY_MAIN_HEADER:
    return { ...state, displayMainHeader: action.payload }
  case DISPLAY_LOADER:
    return { ...state, isLoading: action.payload }
  case DISPLAY_FETCHING_LOADER:
    return { ...state, isFetching: action.payload }
  case DISPLAY_GQ_LOADER:
    return { ...state, isGQLoading: action.payload }
  default:
    return state
  }
}
